export default {
  app_title: "智慧养老管理系统",  // 系统名称
  title: "智慧养老服务平台",  // 系统名称
  area: "智慧养老服务平台", // TODO地区简称
  objectName: "智慧养老服务平台",
  videoName: "智慧养老视频监控中心",
  platformId: 'mengjinyanglao',  // hubeicxzhyl  zhjxZhyl
  // shopPlatformId: 'zhylShopH5',
  shopPlatformId: 'mjylshoph5',
  point: { lng: 112.445248, lat: 34.825678 },
  mapAttr: {
    mapType: "BMAP_NORMAL_MAP",
    zoom: 14
  },
  //url
  hostUrl: '  ',
  apiHttpsUrl: 'https://gateway.anluoyun.cn',
  apiRequestUrl: 'https://gateway.anluoyun.cn',
  apiUploadUrl: 'https://gateway.anluoyun.cn/prod-api/upload/uploadImage',
  apiUploadFiles: 'https://gateway.anluoyun.cn/prod-api/upload/uploadFile',

  // 本地
  // apiHttpsUrl: 'http://192.168.1.5:8018',
  // apiRequestUrl: 'http://192.168.1.5:8018',
  // apiUploadUrl: 'http://192.168.1.5:8018/upload/uploadImage',
  // apiUploadFiles: 'http://192.168.1.5:8018/upload/uploadFile',

  // apiHttpsUrl: 'http://192.168.1.253:8018',
  // apiRequestUrl: 'http://192.168.1.253:8018',
  // apiUploadUrl: 'http://192.168.1.253:8018/upload/uploadImage',
  // apiUploadFiles: 'http://192.168.1.253:8018/upload/uploadFile',

  openapi: 'https://openapi.xiaoxinhuan.com',
  CopyRight: "Copyright @2020-2026 河南安洛云信息科技有限公司 技术服务：400 6379 003",
  // wsSocketUrl: 'wss://zhyl.anluoyun.cn',
  // logo: require("../../src/assets/logo/logo.png"),
  // apiSmartDevicesUrl: 'http://192.168.1.20:9527',
  // apiSmartDevicesUrl: 'http://192.168.110.223:9527',
  apiSmartDevicesUrl: 'https://gateway.anluoyun.cn',

  appKey: "aggbCl4vDbICb6OacVX5",
  AppSecret: "2XoQdPRwwBl1bkIaFdm17LqIJJq97gz28iZqKGh2QCgFOl5gqCSG0HOrgwtgF1Hn",
  extwebUrl: "https://extweb.anluoyun.cn",
  terCode: "PcLQnRmSsXBJoTQrwJ2yQgxBpU46pZih",

}
